<template>
  <div class="wrapper">
    <p class="mobile-description">
      Copie e cole o código de barras para pagamento online.
    </p>
    <p class="desktop-description">
      Escaneie ou copie e cole o código de barras para pagamento online.
    </p>
    <div class="billet-scan_bar">
      <VueBarcode
        format="ITF"
        lineColor="#000"
        :value="barcodeNumber"
        :displayValue="false"
        :fontSize="40"
        :marginLeft="0"
        :width="1"
      />
    </div>
    <span :class="['billet_code', { skeleton: loading }]">
      {{ payNumber | barcodeFilter }}
    </span>
    <div class="button-wrapper mobile">
      <v-popover
        :offset="16"
        placement='top'
        :show="showTooltipCopied"
        :disabled="!showTooltipCopied"
      >
        <Button
          class="primary mb-20"
          content="Copiar código"
          :hasIcon="true"
          :iconName="'copy-white.svg'"
          @click="copyText(payNumber)"
        />

        <template slot="popover">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-text">
            Código copiado
          </div>
        </template>
      </v-popover>
      <Button
        class="semi-primary mb-20"
        content="Baixar boleto"
        @click="downloadBillet()"
      />
    </div>
    <div class="button-wrapper desktop">
      <v-popover
        :offset="16"
        placement='top'
        :show="showTooltipCopied"
        :disabled="!showTooltipCopied"
      >
        <Button
          class="copy-billet-button semi-primary"
          content="Copiar código"
          :hasIcon="true"
          :iconName="'copy.svg'"
          @click="copyText(payNumber), sendEvent({
            action: 'copiou-numero-boleto',
            data: {
              payNumber
            }
        })"
        />
        <template slot="popover">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-text">
            Código copiado
          </div>
        </template>
      </v-popover>
      <Button
        class="download-billet-button secundary"
        content="Baixar boleto"
        @click="downloadBillet(), sendEvent({
          action: 'fez-download-boleto',
          data: {
            payNumber
          }
        })"
      />
    </div>
    <p class="paragraph mb-8">
      Você será avisado assim que o pagamento for confirmado.
      A confirmação pode demorar até 2 dias úteis após a realização do pagamento.
    </p>
    <p class="paragraph">
      Caso o pagamento não seja confirmado em até 3 dias úteis após o vencimento,
      o boleto será cancelado juntamente com o pedido.
    </p>
  </div>
</template>

<script>
import Vue from 'vue';
import VTooltip from 'v-tooltip';
import VueBarcode from 'vue-barcode';
import { mapState } from 'vuex';
import StringMixin from '@/mixins/string';
import UtilMixing from '@/mixins/util';
import Button from './Button.vue';
import ParcelexApi from '../../../services/parcelex';

Vue.use(VTooltip);

export default {
  components: { Button, VueBarcode },
  name: 'BilletDescription',
  mixins: [StringMixin, UtilMixing],
  props: {
    barcodeNumber: {
      type: String,
      default: '',
    },
    payNumber: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      required: true,
    },
    downloadFileName: {
      type: String,
      required: true,
    },
    billetLink: {
      type: String,
      required: true,
    },
    installmentsLink: {
      type: String,
      required: true,
    },
    billetUserId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showTooltipCopied: false,
  }),
  computed: {
    ...mapState('portal', ['user']),
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
      this.showTooltipCopied = true;
      setTimeout(() => {
        this.showTooltipCopied = false;
      }, 2000);
    },
    goToPortal() {
      window.open('http://app.parcelex.com.br/login', '_self');
    },
    downloadBillet() {
      const userId = this.user && this.user.id;
      if (!userId || this.billetUserId !== userId) return this.goToPortal();

      const isMobile = this.isMobile();

      const downloadLink = isMobile
        ? `${this.installmentsLink}:FDL`
        : this.billetLink;

      return fetch(downloadLink)
        .then((response) => response.blob())
        .then((blob) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.downloadFileName;
          link.click();
          link.remove();
        })
        .catch(console.error);
    },
    async sendEvent({ action, data }) {
      const { query } = this.$route;

      ParcelexApi.post('public/event/send', {
        action,
        source: 'billet-page',
        origin: window.location.href.split('?')[0],
        data: {
          ...data,
          ...query,
        },
      }).catch((e) => console.error(e));
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/__new-styles.scss';

  .wrapper {
    grid-column-start: 1;
    grid-column-end: 3;

    @media (min-width: $lg) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .mobile-description {
    font-size: 16px;
    line-height: 24px;
    font-family: var(--font-family);
    color: var(--gray-500);
    font-weight: 600;

    margin-bottom: 16px;

    @media (min-width: $lg) {
      display: none;
    }
  }
  .desktop-description {
    @extend .small-regular;

    font-family: var(--font-family);
    display: none;
    margin-bottom: 20px;
    font-size: 16px;

    @media (min-width: $lg) {
      display: inline-block;
    }
  }
  .billet-scan_bar {
    display: none;

    margin-bottom: 16px;

    @media (min-width: $lg) {
      display: inline-block;
    }
  }
  .barcode {
    width: 350px;
    height: auto;
  }
  .billet_code {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    font-family: var(--font-family);
    color: var(--gray-700);

    word-break: break-all;

    display: inline-block;
    margin-bottom: 16px;

    @media (min-width: $lg) {
      font-size: 14px;
      line-height: 20px;
    }
  }
  .button-wrapper {
    width: 100%;
    @media (min-width: $lg) {
      justify-content: space-between;
      align-items: center;
      gap: 16px;

      width: unset;
    }
  }
  .mobile {
    display: inline-block;
    @media (min-width: $lg) {
      display: none;
    }
  }
  .desktop {
    display: none;
    @media (min-width: $lg) {
      display: flex;
    }
  }
  .paragraph {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    font-family: var(--font-family);
    color: var(--gray-500);

    @media (min-width: $lg) {
      font-size: 14px;
    }
  }
  .v-popover ::v-deep .trigger{
    width: 100% !important;
  }
  .tooltip {
    display: block !important;
    z-index: 2;

    .tooltip-text {
      background: var(--gray-600);
      color: white;
      border-radius: 4px;
      padding: 4px 8px 4px 8px;
      text-align: center;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 1px;
      border-color: var(--gray-600);
      z-index: 1;
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 5px 0;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        border-bottom-color: transparent !important;
        left: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }

  .mb-8 {
    margin-bottom: 8px;
  }

  .copy-billet-button {
    margin-bottom: 20px;

    &:hover {
      background-color: var(--white) !important;
      border: 1px solid var(--blue-300) !important;
    }
  }

  .download-billet-button {
    margin-bottom: 20px;
    background-color: var(--blue-100) !important;

    &:hover {
      background-color: var(--white) !important;
    }
  }

  @media print {
    .billet-scan_bar {
      display: block !important;
    }
  }
</style>

<style lang="scss">
  .copy-billet-button {
    p.white {
      color: var(--gray-700) !important;
      font-weight: 400 !important;
    }

    &:hover {
      p.white {
        color: var(--primary) !important;
      }

      img {
        filter:
          invert(52%)
          sepia(73%)
          saturate(434%)
          hue-rotate(149deg)
          brightness(94%)
          contrast(86%);
      }
    }
  }
</style>
